import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=c819fe1c"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./wysiwyg.vue?vue&type=style&index=0&id=c819fe1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports